module.exports = __webpack_public_path__ + "media/images/icons/place-c2e54ff447b0400a82d8cac40e9cab7b.png";